import styled from 'styled-components';
import React from 'react';
import { getPublicAsset } from 'base/shared/Utils';
import { translate } from 'base/shared/Localization';

const Container = styled.div`
  min-height: 100vh;
  padding: 4rem 0rem;
`;

const MainContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 4rem;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 2.5rem;
    text-align: center;
  }
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 3rem;
  justify-items: center;
`;

const BenefitCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const BenefitImageWrapper = styled.div`
  width: 180px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e7ff;
  border-radius: 50%;
  margin-bottom: 2rem;
`;

const BenefitImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

const BenefitTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 400;
  color: #111827;
  margin-bottom: 1.5rem;
  line-height: 1.3;
  text-align: center;
`;

const BenefitDescription = styled.p`
  font-size: 1rem;
  color: #4b5563;
  line-height: 1.6;
  max-width: 220px;
  text-align: center;
  margin: 0 auto;

  strong {
    color: #111827;
    font-weight: 600;
  }
`;

export default function WhyBadiWorks() {
  return (
    <Container>
      <MainContent>
        <Title>{translate('v2.home.whyBadiWorks.title')}</Title>

        <BenefitsGrid>
          {/* Quick and easy rental */}
          <BenefitCard>
            <BenefitImageWrapper>
              <BenefitImage src={getPublicAsset('v2/images/quick-rental.png')} alt="Quick rental" />
            </BenefitImageWrapper>
            <BenefitTitle>{translate('v2.home.whyBadiWorks.quickRental.title')}</BenefitTitle>
            <BenefitDescription
              dangerouslySetInnerHTML={{
                __html: translate('v2.home.whyBadiWorks.quickRental.desc'),
              }}
            />
          </BenefitCard>

          {/* Community living */}
          <BenefitCard>
            <BenefitImageWrapper>
              <BenefitImage
                src={getPublicAsset('v2/images/community.png')}
                alt="Community living"
              />
            </BenefitImageWrapper>
            <BenefitTitle>{translate('v2.home.whyBadiWorks.community.title')}</BenefitTitle>
            <BenefitDescription
              dangerouslySetInnerHTML={{ __html: translate('v2.home.whyBadiWorks.community.desc') }}
            />
          </BenefitCard>

          {/* Secure payments */}
          <BenefitCard>
            <BenefitImageWrapper>
              <BenefitImage
                src={getPublicAsset('v2/images/secure-payments.png')}
                alt="Secure payments"
              />
            </BenefitImageWrapper>
            <BenefitTitle>{translate('v2.home.whyBadiWorks.securePayments.title')}</BenefitTitle>
            <BenefitDescription
              dangerouslySetInnerHTML={{
                __html: translate('v2.home.whyBadiWorks.securePayments.desc'),
              }}
            />
          </BenefitCard>

          {/* For every lifestyle */}
          <BenefitCard>
            <BenefitImageWrapper>
              <BenefitImage
                src={getPublicAsset('v2/images/lifestyles.png')}
                alt="For every lifestyle"
              />
            </BenefitImageWrapper>
            <BenefitTitle>{translate('v2.home.whyBadiWorks.lifestyle.title')}</BenefitTitle>
            <BenefitDescription
              dangerouslySetInnerHTML={{ __html: translate('v2.home.whyBadiWorks.lifestyle.desc') }}
            />
          </BenefitCard>
        </BenefitsGrid>
      </MainContent>
    </Container>
  );
}
